import axios from "@/api/axios";

export default {
  namespaced: true,

  state: {
    feasibilityProjectList: [],
  },

  getters: {
    feasibilityProjectList: (state) => {
      return state.feasibilityProjectList;
    },
  },

  mutations: {
    GET_PROJECTS(state, payload) {
      state.feasibilityProjectList = payload;
    },
  },

  actions: {
    async getAllFeasibilityProjects({ commit, dispatch }, page) {
      commit("projects/LOADING_STATE", true, { root: true });
      const newPage = page ? `?page=${page}` : "?page=1";
      await axios
        .get("/feasibility-projects" + newPage)
        .then((response) => {
          if (response.data.status === "Success") {
            commit("GET_PROJECTS", response.data.data.data);
            dispatch("projects/getPagination", response.data.data, {
              root: true,
            });
          }
        })
        .catch((err) => {
          console.error("Error from getAllFeasibilityProjects: ", err);
        });
      commit("projects/LOADING_STATE", false, { root: true });
    },
    async getFilteredProjects({ commit, dispatch }, { params, page }) {
      commit("projects/LOADING_STATE", true, { root: true });

      const newPage = page ? `&page=${page}` : "";
      let query = [];

      for (const p in params) {
        query.push(`${p}=${params[p]}`);
      }

      const q = query.join().replace(/,/g, "&");

      await axios
        .get(`/search-projects?${q}${newPage}`)
        .then((response) => {
          if (response.data.status === "Success") {
            commit("GET_PROJECTS", response.data.data.data);
            dispatch("projects/getPagination", response.data.data, {
              root: true,
            });
          }
        })
        .catch((err) => {
          console.error("Error from getAllProjects: ", err);
        });
      commit("projects/LOADING_STATE", false, { root: true });
    },
  },
};
